<template>
    <div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible="dialogFormVisible" width="1000px" :show-close="true" :before-close="handleClose">
            <div v-loading="dialogLoading">
                <div class="remind">* 温馨提醒：只需要填写需要更新的项，不需要更正的项可不填写</div>
                <div class="correct-result">
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">汽配编码</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.APCode" placement="top">
                                    <span>{{ apData.APCode }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.APCode" disabled></el-input></span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">汽配名称</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.GoodName" placement="top">
                                    <span>{{ apData.GoodName }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.GoodName" placeholder="请输入纠正汽配名称"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">产地</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Origin" placement="top">
                                    <span>{{ apData.Origin }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.Origin" placeholder="请输入纠正汽配产地"></el-input></span>
                            </div>
                        </div>

                        <div class="result-cell">
                            <div class="key">英文名称</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.ExAttribute4" placement="top">
                                    <span>{{ apData.ExAttribute4 }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.ExAttribute4" placeholder="请输入纠正汽配英文名称"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">单位</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Unit" placement="top">
                                    <span>{{ apData.Unit }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span>
                                    <el-select v-model="submitData.Unit" filterable allow-create placeholder @visible-change="unitVisibleChange($event)">
                                        <el-option v-for="item in unitList" :key="item.Value" :label="item.Value" :value="item.Value"></el-option>
                                    </el-select>
                                </span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">配件尺寸</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Size + ''" placement="top">
                                    <span>{{ apData.Size }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.Size" placeholder="请输入纠正配件尺寸"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">汽配分类</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.ExAttribute1" placement="top">
                                    <span>{{ apData.ExAttribute1 }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.ExAttribute1" placeholder="请输入纠正汽配分类"></el-input></span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">汽配品牌</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Brand" placement="top">
                                    <span>{{ apData.Brand }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.Brand" placeholder="请输入纠正汽配品牌"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">装箱规格</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.PackingNum + ''" placement="top">
                                    <span>{{ apData.PackingNum }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.PackingNum" placeholder="请输入纠正装箱规格"></el-input></span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">重量</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Quality + ''" placement="top">
                                    <span>{{ apData.Quality }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input type="number" :min="0" class="correct-item" v-model="submitData.Quality" placeholder="请输入纠正重量"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">材质</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Texture" placement="top">
                                    <span>{{ apData.Texture }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.Texture" placeholder="请输入纠正材质"></el-input></span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">颜色</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.Color" placement="top">
                                    <span>{{ apData.Color }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.Color" placeholder="请输入纠正颜色"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">适用车型</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.AutoSerise" placement="top">
                                    <span>{{ apData.AutoSerise }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.AutoSerise" placeholder="请输入纠正适用车型"></el-input></span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">互换码</div>
                            <div class="value">
                                <el-tooltip effect="dark" :content="apData.GoodCode" placement="top">
                                    <span>{{ apData.GoodCode }}</span>
                                </el-tooltip>
                            </div>
                            <div class="editvalue">
                                <span><el-input class="correct-item" v-model="submitData.GoodCode" placeholder="请输入纠正互换码"></el-input></span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell-h">
                            <div class="key">包装尺寸</div>
                            <div class="value">
                                <span>{{ apData.Length + ' x ' + apData.Width + ' x ' + apData.Height }}</span>
                            </div>
                            <div class="editvalue">
                                <span><el-input-number class="correct-item" v-model="submitData.Length" placeholder="请输入纠正包装尺寸的长" :min="0"></el-input-number> </span>
                            </div>
                            &nbsp;&nbsp; X &nbsp;&nbsp;
                            <div class="editvalue">
                                <span>
                                    <el-input-number class="correct-item" v-model="submitData.Width" placeholder="请输入纠正包装尺寸的宽" :min="0"></el-input-number>
                                </span>
                            </div>
                            &nbsp;&nbsp; X &nbsp;&nbsp;
                            <div class="editvalue">
                                <span>
                                    <el-input-number class="correct-item" v-model="submitData.Height" placeholder="请输入纠正包装尺寸的高" :min="0"></el-input-number>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 15px; padding-bottom: 15px">
                    <el-button v-if="SType == 0" class="search-btn btn-primary" @click="saveEnterprisePart" style="margin-right: 28px">提交纠错数据</el-button>
                    <el-button v-if="SType == 1" class="search-btn" type="warning" @click="IgnoreCorrectUnionGoodsData">忽略该纠错</el-button>
                    <el-button v-if="SType == 1" class="search-btn btn-primary" @click="ConfirmCorrectUnionGoodsData" style="margin-right: 28px">审核通过</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        SType: Number,
        UnionGoodsId: String,
        CorrectId: String,
        dialogFormVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '配件信息纠错',
            dialogLoading: false,
            loading: false,
            brandList: [],
            apCategoryList: [],
            seriesList: [],
            unitList: [],
            apData: {},
            submitData: {
                GoodsId: this.UnionGoodsId,
                UnionId: this.$util.getLocalStorage('currentUnion'),
                APCode: '',
                AutoSerise: '',
                Brand: '',
                Color: '',
                ExAttribute1: '',
                ExAttribute4: '',
                GoodCode: '',
                GoodDesc: '',
                GoodName: '',
                Height: 0,
                Length: 0,
                Origin: '',
                PackingNum: '',
                Quality: 0,
                Size: '',
                Texture: '',
                Unit: '',
                Width: 0
            }
        };
    },
    mounted() {
        if (this.SType == 0) {
            if (this.UnionGoodsId) this.getUnionGoodsDetail();
            else this.$util.warningMsg('联盟商品信息异常，请刷新后重新操作');
        } else if (this.SType == 1) {
            if (this.CorrectId) this.getGoodsCorrectDetail();
            else this.$util.warningMsg('纠错信息异常，请刷新后重新操作');
        }
    },
    methods: {
        //关闭商品编辑dialog
        handleClose() {
            let that = this;
            if (this.SType == 0)
                that.$confirm('纠错的信息将不会保存, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.$emit('closeDialog');
                    })
                    .catch(() => {});
            else that.$emit('closeDialog');
        },

        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length <= 1) that.getConfigData();
            }
        },
        //获取单位
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        saveEnterprisePart() {
            let that = this;
            if (
                that.submitData.AutoSerise == '' &&
                that.submitData.Brand == '' &&
                that.submitData.Color == '' &&
                that.submitData.ExAttribute1 == '' &&
                that.submitData.ExAttribute4 == '' &&
                that.submitData.GoodCode == '' &&
                that.submitData.GoodDesc == '' &&
                that.submitData.GoodName == '' &&
                that.submitData.Height == 0 &&
                that.submitData.Length == 0 &&
                that.submitData.Origin == '' &&
                that.submitData.PackingNum == '' &&
                that.submitData.Quality == 0 &&
                that.submitData.Size == '' &&
                that.submitData.Texture == '' &&
                that.submitData.Unit == '' &&
                that.submitData.Width == 0
            ) {
                that.$util.warningMsg('您未进行任何的纠正哟');
                return;
            }
            that.dialogLoading = true;

            that.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/SaveCorrectUnionGoodsData',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg(res.errmsg);
                        that.$emit('closeDialog');
                    }
                })
                .catch(error => {
                    that.dialogLoading = false;
                });
        },
        ConfirmCorrectUnionGoodsData() {
            let that = this;
            if (
                that.submitData.AutoSerise == '' &&
                that.submitData.Brand == '' &&
                that.submitData.Color == '' &&
                that.submitData.ExAttribute1 == '' &&
                that.submitData.ExAttribute4 == '' &&
                that.submitData.GoodCode == '' &&
                that.submitData.GoodDesc == '' &&
                that.submitData.GoodName == '' &&
                that.submitData.Height == 0 &&
                that.submitData.Length == 0 &&
                that.submitData.Origin == '' &&
                that.submitData.PackingNum == '' &&
                that.submitData.Quality == 0 &&
                that.submitData.Size == '' &&
                that.submitData.Texture == '' &&
                that.submitData.Unit == '' &&
                that.submitData.Width == 0
            ) {
                that.$util.warningMsg('您未进行任何的纠正哟');
                return;
            }
            that.dialogLoading = true;
            that.submitData.GoodsId = that.CorrectId;
            that.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/ConfirmCorrectUnionGoodsData',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg(res.errmsg);
                        that.$emit('closeDialog', true);
                    }
                })
                .catch(error => {
                    that.dialogLoading = false;
                });
        },
        IgnoreCorrectUnionGoodsData() {
            let that = this;
            that.dialogLoading = true;

            that.$util
                .axiosPost({
                    url: `/api/EntpUnionGoods/IgnoreCorrectUnionGoodsData?CorrectId=${this.CorrectId}`,
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg(res.errmsg);
                        that.$emit('closeDialog', true);
                    }
                })
                .catch(error => {
                    that.dialogLoading = false;
                });
        },
        //获取配件信息
        getUnionGoodsDetail() {
            let that = this;
            that.dialogLoading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionGoodsDetail',
                    data: {
                        GoodsId: that.UnionGoodsId,
                        UnionId: that.$util.getLocalStorage('currentUnion')
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;

                    if (data.PackageSize) {
                        let packageSize = data.PackageSize.split('*');
                        if (packageSize) {
                                data.Length = packageSize[0];
                                data.Width = packageSize[1];
                                data.Height = packageSize[2];
                            }
                    } else {
                        data.Length = 0;
                        data.Width = 0;
                        data.Height = 0;
                    }
                    if (data.GoodDesc) {
                        let goodDescArr = data.GoodDesc.split('|').map(m => {
                            let i = m.split(':');
                            return {
                                key: i[0],
                                value: i[1]
                            };
                        });
                        data.GoodDesc = goodDescArr;
                    } else {
                        data.GoodDesc = [{ key: '', value: '' }];
                    }
                    that.apData = data;
                    that.submitData.APCode = data.APCode;
                })
                .catch(() => {
                    that.dialogLoading = false;
                })
                .finally(() => {
                    that.dialogLoading = false;
                });
        },
        getGoodsCorrectDetail() {
            let that = this;
            that.dialogLoading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionGoodsCorrectData',
                    data: {
                        CorrectId: that.CorrectId,
                        UnionId: that.$util.getLocalStorage('currentUnion')
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.apData = data.APData;
                    that.submitData = data.CorrectData;
                })
                .catch(() => {
                    that.dialogLoading = false;
                })
                .finally(() => {
                    that.dialogLoading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.remind {
    width: 900px;
    margin: 0 auto;
    padding-top: 10px;
    padding-bottom: 10px;
    color: red;
}
</style>
<style lang="less">
.correct-result {
    width: 900px;
    margin: 0 auto;
    border-bottom: 1px solid #dcdfe6;

    .result-row {
        display: flex;
        border-right: 1px solid #dcdfe6;
    }
    .result-cell {
        width: 450px;
        display: flex;
        align-items: center;
        border-top: 1px solid #dcdfe6;

        .key {
            height: 46px;
            line-height: 46px;
            width: 90px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }
        .value {
            width: 170px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
        .editvalue {
            width: 190px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
        }
    }
    .result-cell-h {
        width: 900px;
        display: flex;
        align-items: center;
        border-top: 1px solid #dcdfe6;

        .key {
            height: 46px;
            line-height: 46px;
            width: 90px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }
        .value {
            width: 170px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
        .editvalue {
            display: flex;
            flex-direction: row;
            width: 190px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
        }
    }
    .el-input__inner {
        height: 46px;
        border-radius: 0;
        line-height: 46px;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
        height: 44px;
        line-height: 44px;
    }
    .el-input-number {
        width: 190px;
    }
}
</style>
